(function () {
  document.addEventListener("alpine:init", function () {
    Alpine.data("videoTogglerBinaery", function (initialPlay) {
      return {
        isPlaying: initialPlay === true,
        poster: true,
        getVideo: function () {
          if (this.$refs.video) return this.$refs.video;
          return this.$el.querySelector("video");
        },
        onOtherVideoPlay: function (event) {
          const detail = event.detail;
          if (detail && detail.source === this.$el) return;
          this.pauseVideo();
        },
        init: function () {
          const self = this;
          const video = this.getVideo();
          if (!video) return;

          let pointerStartX = 0;
          let pointerStartY = 0;
          let pointerMoved = false;
          const moveThreshold = 8;

          video.addEventListener("play", function () {
            self.isPlaying = true;
          });
          video.addEventListener("pause", function () {
            self.isPlaying = false;
          });

          video.addEventListener("pointerdown", function (event) {
            pointerStartX = event.clientX;
            pointerStartY = event.clientY;
            pointerMoved = false;
          });

          video.addEventListener("pointermove", function (event) {
            if (pointerMoved) return;
            const deltaX = Math.abs(event.clientX - pointerStartX);
            const deltaY = Math.abs(event.clientY - pointerStartY);
            if (deltaX > moveThreshold || deltaY > moveThreshold) {
              pointerMoved = true;
            }
          });

          video.addEventListener("pointerup", function (event) {
            if (pointerMoved) return;

            const scrollerEl = self.$el.closest(".binaery-video-scroller");
            if (
              scrollerEl &&
              scrollerEl.swiper &&
              scrollerEl.swiper.allowClick === false
            ) {
              return;
            }

            event.preventDefault();
            self.togglePlay();
          });

          video.addEventListener("pointercancel", function () {
            pointerMoved = true;
          });
        },
        togglePlay: function () {
          const video = this.getVideo();
          if (!video) return;
          this.poster = false;

          if (video.paused) {
            video.muted = false;
            video.volume = 1;
            this.$dispatch("binaery-video-play", { source: this.$el });
            video.play();
          } else {
            video.pause();
          }
        },
        pauseVideo: function () {
          const video = this.getVideo();
          if (video) video.pause();
          this.isPlaying = false;
        },
      };
    });

    Alpine.data("videoScrollerBinaery", function () {
      return {
        swiper: null,
        initSwiper: function () {
          const self = this;
          const container = this.$refs.swiper;
          if (!container || typeof Swiper === "undefined" || this.swiper) return;

          this.swiper = new Swiper(container, {
            slidesPerView: "auto",
            spaceBetween: 12,
            grabCursor: true,
            threshold: 8,
            resistanceRatio: 0.85,
            preventClicks: true,
            preventClicksPropagation: true,
            touchStartPreventDefault: false,
            touchEventsTarget: "wrapper",
            watchOverflow: true,
            observer: true,
            observeParents: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            breakpoints: {
              0: {
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
              },
              768: {
                slidesOffsetBefore: 40,
                slidesOffsetAfter: 40,
              },
              1024: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
              },
            },
            on: {
              init: function () {
                requestAnimationFrame(function () {
                  if (!self.swiper) return;
                  self.swiper.update();
                });
              },
            },
          });
        },
        init: function () {
          const self = this;
          const tryInit = function () {
            if (typeof Swiper === "undefined") return false;
            self.initSwiper();
            return true;
          };

          if (!tryInit()) {
            window.addEventListener("load", tryInit, { once: true });
          }
        },
      };
    });

    Alpine.data("binaeryPdp", function (configOrId) {
      let cfg = configOrId || {};
      if (typeof configOrId === "string") {
        const configEl = document.getElementById(configOrId);
        cfg = {};
        if (configEl && configEl.textContent) {
          try {
            cfg = JSON.parse(configEl.textContent);
          } catch (parseErr) {
            cfg = {};
          }
        }
      }
      const cards = cfg.cards || [];
      const discounts = cfg.discounts || [];
      const moneyFormat = cfg.moneyFormat || "${{amount}}";
      const freeShippingLabel = cfg.freeShippingLabel || "+ FREE shipping";
      const giftEnabled = cfg.giftEnabled === true;
      const otpGiftEnabled = cfg.otpGiftEnabled === true;
      const subscriptionPriceDivided = cfg.subscriptionPriceDivided === true;
      const giftVariantId = cfg.giftVariantId || null;
      const productId = cfg.productId || null;
      const fulfillmentMode = cfg.fulfillmentMode || null;

      function formatFreeShippingLabel(label) {
        if (!label) return "+ FREE shipping";
        let text = String(label).trim();
        text = text.replace(/^\+\s*/, "+ ");
        text = text.replace(/free\s*shipping/i, "FREE shipping");
        return text;
      }
      const getPercentOffLabel = cfg.getPercentOffLabel || "GET [[percent]]% OFF";
      const saveOnEveryOrderLabel =
        cfg.saveOnEveryOrderLabel || "Save [[percent]]% on every order";
      const otpDisplay = cfg.otpDisplay || "off";
      const otpEnabled = otpDisplay !== "off";
      const otpButtonLabel = cfg.otpButtonLabel || "Buy Once for [[price]] + Shipping";
      const paymentTextTemplate =
        cfg.paymentTextTemplate || "Pay in [[count]] payments of [[price]] with";
      const paymentInstallmentsCount = cfg.paymentInstallmentsCount || 4;

      function formatGetPercentOffLabel(pct) {
        return getPercentOffLabel.replace("[[percent]]", String(pct));
      }

      function formatSaveOnEveryOrderLabel(pct) {
        return saveOnEveryOrderLabel.replace("[[percent]]", String(pct));
      }

      function formatOtpButtonLabel(priceText) {
        return otpButtonLabel.replace("[[price]]", priceText);
      }

      function formatPaymentLineText(priceText) {
        return paymentTextTemplate
          .replace("[[price]]", priceText)
          .replace("[[count]]", String(paymentInstallmentsCount));
      }

      function getUnitSubPrice(card, planId) {
        if (!card) return 0;
        const base = card.price || 0;
        if (planId) {
          const pct = findDiscount(card.variant_id, planId);
          return base - Math.round((base * pct) / 100);
        }
        return base;
      }

      function buildMainCartPayload(card, options) {
        const opts = options || {};
        const quantity = this.getCardItemCount(card);
        // No Bags property — Shopify merges on variant + selling_plan only.
        const payload = {
          id: card.variant_id,
          quantity: quantity,
        };

        if (opts.includeSellingPlan !== false && this.sellingPlanId) {
          payload.selling_plan = parseInt(this.sellingPlanId, 10);
        }

        return payload;
      }

      function buildOtpCartPayload(card) {
        const bagCount = this.getCardItemCount(card);
        const variantId = card.otp_variant_id || card.variant_id;

        return {
          id: variantId,
          quantity: bagCount,
        };
      }

      function getCartJsonUrl() {
        if (window.routes && window.routes.cart_url) {
          return window.routes.cart_url.replace(/\/cart\/?$/, "/cart.js");
        }
        return "/cart.js";
      }

      function getSectionsPayload() {
        const cartDrawer = document.querySelector("cart-drawer");
        if (
          cartDrawer &&
          typeof cartDrawer.getSectionsToRender === "function"
        ) {
          return {
            sections: cartDrawer.getSectionsToRender().map(function (s) {
              return s.id;
            }),
            sections_url: window.location.pathname,
          };
        }
        return {};
      }

      function isGiftCartItem(item) {
        return !!(item && item.properties && item.properties._gift_item);
      }

      function getItemSellingPlanId(item) {
        if (
          item &&
          item.selling_plan_allocation &&
          item.selling_plan_allocation.selling_plan &&
          item.selling_plan_allocation.selling_plan.id
        ) {
          return String(item.selling_plan_allocation.selling_plan.id);
        }
        return "";
      }

      function findMatchingProteinLines(cart, variantId, sellingPlanId) {
        const matches = [];
        if (!cart || !cart.items || cart.items.length === 0) return matches;

        const targetPlan = sellingPlanId ? String(sellingPlanId) : "";

        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          if (isGiftCartItem(item)) continue;
          if (String(item.variant_id) !== String(variantId)) continue;

          const itemPlan = getItemSellingPlanId(item);
          if (targetPlan) {
            if (itemPlan === targetPlan) {
              matches.push(item);
            }
          } else if (!itemPlan) {
            matches.push(item);
          }
        }

        return matches;
      }

      function cartHasGift(cart) {
        if (!cart || !cart.items) return false;
        for (let i = 0; i < cart.items.length; i++) {
          if (isGiftCartItem(cart.items[i])) return true;
        }
        return false;
      }

      function finishCartResponse(self, res) {
        self.adding = false;

        if (!res || res.status) {
          return;
        }

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          if (res.sections && typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents(res);
          } else {
            cartDrawer.classList.remove("is-empty");
            if (typeof cartDrawer.open === "function") {
              cartDrawer.open();
            }
            if (typeof window.refreshCartIconBubble === "function") {
              window.refreshCartIconBubble();
            }
          }
        } else if (typeof window.refreshCartIconBubble === "function") {
          window.refreshCartIconBubble();
        }
      }

      function cartAjaxUrl(routeUrl, fallback) {
        const base = routeUrl || fallback;
        if (!base) return fallback;
        if (base.slice(-3) === ".js") return base;
        return base + ".js";
      }

      function postJson(url, body) {
        return fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        }).then(function (res) {
          if (!res.ok) throw new Error("Cart error " + res.status);
          return res.json();
        });
      }

      function stackOrAddCartItem(self, payload, options) {
        const opts = options || {};
        const sections = getSectionsPayload();
        const tracking = window.ForallCartTracking;
        const giftParentId = opts.giftParentId || productId;
        const split = window.ForallProteinSplit;
        const splitMode = opts.mode || fulfillmentMode || (split && split.getMode ? split.getMode() : 'off');
        const canSplit =
          split &&
          typeof split.isEnabled === 'function' &&
          split.isEnabled() &&
          splitMode !== 'off';

        // No Bags on new adds — Shopify merges on variant + selling_plan.
        // Legacy Bags lines are stripped once before add.
        const cleanPayload = {
          id: payload.id,
          quantity: payload.quantity || 1,
        };
        if (payload.selling_plan) {
          cleanPayload.selling_plan = payload.selling_plan;
        }

        self.adding = true;

        if (canSplit) {
          fetch(getCartJsonUrl(), { headers: { Accept: 'application/json' } })
            .then(function (res) {
              if (!res.ok) throw new Error('Cart fetch error');
              return res.json();
            })
            .then(function (cart) {
              const cfg = split.getConfig();
              let kitVariantId = cfg.kitSingleVariantId || cfg.kitVariantId;
              let bagVariantId = cfg.bagVariantId;

              if (splitMode === 'kit') {
                if (cleanPayload.selling_plan) {
                  kitVariantId = cleanPayload.id || kitVariantId;
                }
              } else if (splitMode === 'bag') {
                bagVariantId = cleanPayload.id || bagVariantId;
              }

              const items = split.buildSplitItems({
                quantity: cleanPayload.quantity,
                sellingPlanId: cleanPayload.selling_plan || '',
                frequencyKey: split.planKeyFromId ? split.planKeyFromId(cleanPayload.selling_plan) : '',
                kitVariantId: kitVariantId,
                bagVariantId: bagVariantId,
                includeGift: opts.includeGift === true,
                giftVariantId: giftVariantId || cfg.giftVariantId,
                giftParentId: giftParentId,
                cart: cart,
                mode: splitMode,
              });

              if (!items || items.length === 0) {
                throw new Error('Protein split produced no items');
              }

              return split.addItems(items, sections);
            })
            .then(function (res) {
              finishCartResponse(self, res);
            })
            .catch(function () {
              self.adding = false;
            });
          return;
        }

        const postAdd = function (body) {
          if (sections.sections) {
            body.sections = sections.sections;
            body.sections_url = sections.sections_url;
          }
          return postJson(
            cartAjaxUrl(
              window.routes && window.routes.cart_add_url,
              "/cart/add.js"
            ),
            body
          );
        };

        const needsGiftCheck =
          opts.includeGift && giftEnabled && giftVariantId;

        // Fast path: strip legacy Bags if needed, then one /cart/add.js.
        if (!needsGiftCheck) {
          const stripPromise =
            tracking && typeof tracking.stripBagsForVariant === "function"
              ? tracking.stripBagsForVariant(
                  cleanPayload.id,
                  cleanPayload.selling_plan || ""
                )
              : Promise.resolve(null);

          stripPromise
            .then(function () {
              return postAdd(Object.assign({}, cleanPayload));
            })
            .then(function (res) {
              finishCartResponse(self, res);
            })
            .catch(function () {
              self.adding = false;
            });
          return;
        }

        fetch(getCartJsonUrl(), {
          headers: { Accept: "application/json" },
        })
          .then(function (res) {
            if (!res.ok) throw new Error("Cart fetch error");
            return res.json();
          })
          .then(function (cart) {
            const matches =
              tracking && typeof tracking.findMatchingProteinLines === "function"
                ? tracking.findMatchingProteinLines(
                    cart,
                    cleanPayload.id,
                    cleanPayload.selling_plan || ""
                  )
                : findMatchingProteinLines(
                    cart,
                    cleanPayload.id,
                    cleanPayload.selling_plan || ""
                  );

            const stripPromise =
              tracking && typeof tracking.stripBagsFromMatchingLines === "function"
                ? tracking.stripBagsFromMatchingLines(matches)
                : Promise.resolve(null);

            return stripPromise.then(function () {
              if (tracking && typeof tracking.markBagsClean === "function") {
                tracking.markBagsClean(
                  cleanPayload.id,
                  cleanPayload.selling_plan || ""
                );
              }

              // First add (sub or OTP with gift): gift + product in one add.js.
              // Later adds: main item only — merges into the existing line.
              if (!cartHasGift(cart)) {
                return postAdd({
                  items: [
                    {
                      id: giftVariantId,
                      quantity: 1,
                      properties: {
                        _gift_item: String(giftParentId),
                      },
                    },
                    cleanPayload,
                  ],
                });
              }

              return postAdd(Object.assign({}, cleanPayload));
            });
          })
          .then(function (res) {
            finishCartResponse(self, res);
          })
          .catch(function () {
            self.adding = false;
          });
      }

      function biCurrency(cents, stripTrailingZeros) {
        let formatted;
        if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
          formatted = Shopify.formatMoney(cents, moneyFormat);
        } else {
          const amount = (cents / 100).toFixed(2);
          formatted = "$" + amount;
        }
        if (stripTrailingZeros) {
          return formatted.replace(/\.00$/, "");
        }
        return formatted;
      }

      function findDiscount(variantId, planId) {
        for (let i = 0; i < discounts.length; i++) {
          const entry = discounts[i];
          if (
            String(entry.variant) === String(variantId) &&
            String(entry.plan) === String(planId)
          ) {
            return Math.round(entry.discount);
          }
        }
        return 0;
      }

      function getForcedSellingPlanId(card) {
        if (!card || !card.plans || card.plans.length === 0) return "";
        if (card.default_selling_plan_id) {
          for (let i = 0; i < card.plans.length; i++) {
            if (String(card.plans[i].id) === String(card.default_selling_plan_id)) {
              return String(card.plans[i].id);
            }
          }
        }
        return String(card.plans[0].id);
      }

      return {
        planType: cfg.defaultPlan || "subscription",
        selectedCardIndex: cfg.defaultCardIndex || 0,
        sellingPlanId: cfg.defaultSellingPlanId || "",
        adding: false,
        otpEnabled: otpEnabled,
        otpDisplay: otpDisplay,
        subscriptionPriceDivided: subscriptionPriceDivided,
        cards: cards,
        discounts: discounts,
        moneyFormat: moneyFormat,
        init: function () {
          const card = this.getSelectedCard();
          const forcedId = getForcedSellingPlanId(card);
          if (forcedId) {
            this.sellingPlanId = forcedId;
          }
          this.syncPlanRadios();
          this.syncVariantGallery();
        },
        syncVariantGallery: function () {
          const card = this.getSelectedCard();
          if (!card || !card.image_src) return;
          this.$dispatch("binaery-variant-changed", {
            variantId: card.variant_id,
            featuredMediaId: card.featured_media_id,
            imageSrc: card.image_src,
            thumbSrc: card.thumb_src,
            imageAlt: card.image_alt || "",
          });
        },
        syncPlanRadios: function () {
          const radios = document.querySelectorAll('input[name="plan"]');
          if (!radios || radios.length === 0) return;
          const target = this.planType === "onetime" ? "onetime" : "subscription";
          for (let i = 0; i < radios.length; i++) {
            const radio = radios[i];
            const checked = radio.value === target;
            radio.checked = checked;
            if (checked) {
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        },
        getSelectedCard: function () {
          if (!this.cards || this.cards.length === 0) return null;
          let idx = this.selectedCardIndex;
          if (idx < 0) idx = 0;
          if (idx >= this.cards.length) idx = this.cards.length - 1;
          return this.cards[idx];
        },
        selectPlan: function (type) {
          const nextType = type === "onetime" ? "onetime" : "subscription";
          this.planType = nextType;
          this.syncPlanRadios();
          this.$dispatch("binaery-plan-changed", { planType: nextType });
        },
        selectCard: function (index) {
          this.selectedCardIndex = index;
          const newCard = this.cards[index];
          const forcedId = getForcedSellingPlanId(newCard);
          if (forcedId) {
            this.sellingPlanId = forcedId;
          }

          this.syncVariantGallery();
        },
        setSellingPlan: function (planId) {
          this.sellingPlanId = String(planId);
        },
        getCardComparePrice: function (card) {
          if (!card) return 0;
          return this.getCardComparePricePerItem(card);
        },
        getCardComparePricePerItem: function (card) {
          if (!card) return 0;
          const compare = card.compare_price || 0;
          const price = card.price || 0;
          if (compare > 0) return compare;
          return price;
        },
        getSavePriceAmountCents: function (card) {
          if (!card || card.save_price_amount == null || card.save_price_amount === "") {
            return 0;
          }
          const raw = String(card.save_price_amount).replace(/[^0-9.]/g, "");
          const dollars = parseFloat(raw);
          if (!dollars || dollars <= 0) return 0;
          return Math.round(dollars * 100);
        },
        getCardSubPrice: function (card) {
          if (!card) return 0;
          if (card.save_price_mode === "amount") {
            const amountOff = this.getSavePriceAmountCents(card);
            if (amountOff > 0) {
              return Math.max(0, this.getCardOtpPrice(card) - amountOff);
            }
          }
          const pct = this.getDiscountPct(card);
          const compare = this.getCardComparePricePerItem(card);
          if (pct > 0 && compare > 0) {
            const perItem = compare - Math.round((compare * pct) / 100);
            return perItem * this.getCardItemCount(card);
          }
          return (
            getUnitSubPrice(card, this.getCardCurrentPlanId(card)) *
            this.getCardItemCount(card)
          );
        },
        getCardOtpPrice: function (card) {
          if (!card) return 0;
          if (card.otp_variant_id && card.otp_price) {
            return card.otp_price * this.getCardItemCount(card);
          }
          return this.getCardOtpPricePerItem(card) * this.getCardItemCount(card);
        },
        getCardDisplayPrice: function (card) {
          return this.getCardSubPrice(card);
        },
        getCardItemCount: function (card) {
          if (!card) return 1;
          let count = parseInt(card.item_count, 10);
          if (!count || count < 1) {
            count = parseInt(card.price_divider, 10);
          }
          if (!count || count < 1) count = 1;
          return count;
        },
        getCardSubPricePerItem: function (card) {
          if (!card) return 0;
          const count = this.getCardItemCount(card);
          return Math.round(this.getCardSubPrice(card) / count);
        },
        getCardOtpPricePerItem: function (card) {
          if (!card) return 0;
          if (card.otp_variant_id && card.otp_price) {
            return card.otp_price;
          }
          return this.getCardComparePricePerItem(card);
        },
        getSubscriptionComparePrice: function (card) {
          if (!card) return 0;
          if (this.subscriptionPriceDivided) {
            return this.getCardOtpPricePerItem(card);
          }
          return this.getCardOtpPrice(card);
        },
        getSubscriptionPrice: function (card) {
          if (!card) return 0;
          if (this.subscriptionPriceDivided) {
            return this.getCardSubPricePerItem(card);
          }
          return this.getCardSubPrice(card);
        },
        getOtpDisplayPrice: function (card) {
          if (!card) return 0;
          if (this.subscriptionPriceDivided) {
            return this.getCardOtpPricePerItem(card);
          }
          return this.getCardOtpPrice(card);
        },
        getAtcPrice: function () {
          const card = this.getSelectedCard();
          if (!card) return 0;
          if (this.planType === "onetime") {
            return this.getCardOtpPrice(card);
          }
          return this.getCardSubPrice(card);
        },
        getPaymentInstallmentsCount: function (count) {
          let installments = parseInt(count, 10);
          if (!installments || installments < 1) installments = 4;
          return installments;
        },
        getAtcPaymentPrice: function (count) {
          const installments = this.getPaymentInstallmentsCount(count);
          const atcPrice = this.getAtcPrice();
          if (!atcPrice) return 0;
          return Math.round(atcPrice / installments);
        },
        getPaymentLineText: function () {
          const priceText = biCurrency(
            this.getAtcPaymentPrice(paymentInstallmentsCount)
          );
          return formatPaymentLineText(priceText);
        },
        getPerServing: function (card) {
          if (!card) return "";
          const display = this.getCardDisplayPrice(card);
          let servings = card.servings || 20;
          if (servings < 1) servings = 1;
          const per = Math.round(display / servings);
          return biCurrency(per);
        },
        getSubPerServing: function (card) {
          if (!card || !card.servings || card.servings < 1) return "";
          return biCurrency(Math.round(this.getCardSubPrice(card) / card.servings));
        },
        getOtpPerServing: function (card) {
          if (!card || !card.servings || card.servings < 1) return "";
          return biCurrency(Math.round(this.getCardOtpPrice(card) / card.servings));
        },
        getCardCurrentPlanId: function (card) {
          if (!card || !card.plans || card.plans.length === 0) return "";
          let slotIndex = 0;
          const selected = this.getSelectedCard();
          if (selected && selected.plans) {
            for (let i = 0; i < selected.plans.length; i++) {
              if (String(selected.plans[i].id) === String(this.sellingPlanId)) {
                slotIndex = i;
                break;
              }
            }
          }
          const idx = slotIndex < card.plans.length ? slotIndex : 0;
          return card.plans[idx].id;
        },
        getDiscountPct: function (card) {
          if (!card) return 0;
          if (card.save_badge_mode === "manual" && card.save_badge_manual) {
            return parseInt(card.save_badge_manual, 10) || 0;
          }
          const planId = this.getCardCurrentPlanId(card);
          if (!planId) return 0;
          return findDiscount(card.variant_id, planId);
        },
        formatSaveBadgeText: function (text, card) {
          if (!text) return "";
          const pct = this.getDiscountPct(card);
          const value = String(pct);
          return String(text)
            .replace(/\{value\}/g, value)
            .replace(/\{discount\}/g, value);
        },
        getSaveBadgeLabel: function (card) {
          if (!card) return "";
          if (card.save_badge_text) {
            return this.formatSaveBadgeText(card.save_badge_text, card);
          }
          const pct = this.getDiscountPct(card);
          if (pct > 0) {
            return formatGetPercentOffLabel(pct);
          }
          return "";
        },
        getMaxSubDiscount: function () {
          let max = 0;
          for (let i = 0; i < this.cards.length; i++) {
            const pct = this.getDiscountPct(this.cards[i]);
            if (pct > max) max = pct;
          }
          return max;
        },
        getUpToSaveLabel: function () {
          const pct = this.getMaxSubDiscount();
          if (pct <= 0) return "";
          return "UP TO " + String(pct) + "% OFF";
        },
        getSaveOnEveryOrderLabel: function () {
          const card = this.getSelectedCard();
          if (!card) return "";
          const pct = this.getDiscountPct(card);
          if (pct <= 0) return "";
          return formatSaveOnEveryOrderLabel(pct);
        },
        getQuantitySaveLine: function (card) {
          let label = "";
          if (card && card.save_badge_text) {
            label = this.formatSaveBadgeText(card.save_badge_text, card);
          } else {
            const pct = this.getDiscountPct(card);
            if (pct > 0) label = "Save " + String(pct) + "%";
          }
          if (card && card.show_free_shipping) {
            const fsLabel = formatFreeShippingLabel(freeShippingLabel);
            if (label) return label + " " + fsLabel;
            return fsLabel;
          }
          return label;
        },
        getOtpSaveBadgeLabel: function (card) {
          if (!card) return "";
          const compare = this.getCardComparePricePerItem(card);
          const price = this.getCardOtpPricePerItem(card);
          if (compare <= price) return "";
          const pct = Math.round(((compare - price) / compare) * 100);
          if (pct <= 0) return "";
          return "Save " + String(pct) + "%";
        },
        getOtpButtonLabel: function () {
          const card = this.getSelectedCard();
          if (!card) return "";
          return formatOtpButtonLabel(
            biCurrency(this.getCardOtpPrice(card), true)
          );
        },
        biCurrency: biCurrency,
        isSubscription: function () {
          return this.planType === "subscription";
        },
        addToCart: function () {
          const card = this.getSelectedCard();
          if (!card || this.adding) return;

          const self = this;
          if (this.planType === "onetime") {
            const otpPayload = buildOtpCartPayload.call(this, card);
            stackOrAddCartItem(self, otpPayload, {
              includeGift: otpGiftEnabled,
              giftParentId: productId,
              mode: fulfillmentMode,
            });
            return;
          }

          const mainPayload = buildMainCartPayload.call(this, card);
          stackOrAddCartItem(self, mainPayload, {
            includeGift: true,
            giftParentId: productId,
            mode: fulfillmentMode,
          });
        },
        addOtpToCart: function () {
          const card = this.getSelectedCard();
          if (!card || this.adding) return;

          const self = this;
          const mainPayload = buildOtpCartPayload.call(this, card);
          stackOrAddCartItem(self, mainPayload, {
            includeGift: otpGiftEnabled,
            giftParentId: productId,
            mode: fulfillmentMode,
          });
        },
      };
    });
  });

})();
